import { JSEncrypt } from 'jsencrypt';
import store from "@/store";

// 工具类
// 获取地址栏参数
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  var context = "";
  if (r != null) context = decodeURIComponent(r[2]);
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined"
    ? ""
    : context;
}

// 是否手机端
export const isMobile = () =>  window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);


// 获取当前环境

export function envjudge() {
  var isMobile = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  ); // 是否手机端
  var isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
  var isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
  if (isComWx && isMobile) {
    // 手机端企业微信
    return "com-wx-mobile";
  } else if (isComWx && !isMobile) {
    // PC端企业微信
    return "com-wx-pc";
  } else if (isWx && isMobile) {
    // 手机端微信
    return "wx-mobile";
  } else if (isWx && !isMobile) {
    // PC端微信
    return "wx-pc";
  } else {
    return "other";
  }
}

export function getCurrUserInfo() {
    // 待处理
//   return localStorage.getItem(`userInfo${}`)
}

/**
 * 字段加密
 * @param text
 * @returns {string|*}
 */
/* eslint-disable */
export const encryptedRender = (text) => {
    if(text.length){
        text = text.toString().trim()
        if(text.length <= 1){
            return '*';
        }else if(text.length === 2){
            return hideCode(text, 1, 0);
        }else if(text.length >= 3 && text.length <= 6){
            return hideCode(text, 1, 1);
        }else if(text.length === 7){
            return hideCode(text, 2, 2);
        }else if(text.length === 8){
            return hideCode(text, 2, 2);
        }else if(text.length === 9){
            return hideCode(text, 2, 3);
        }else if(text.length === 10){
            return hideCode(text, 3, 3);
        }else if(text.length >= 11 && text.length <= 20){
            return hideCode(text, 3, 4);
        }else if(text.length >= 20 && text.length <= 40){
            return hideCode(text, 8, 8);
        }else if(text.length > 40){
            return hideCode(text, 16, 16);
        }
    }
    return text
}

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export const getFileAccessHttpUrl = (avatar, subStr, projectType) => {
    // console.log(91111,avatar, subStr, projectType);
    // console.log(93,2222);
    let staticDomainURL = '';
    // console.log(96,store.getters.tenantId, process.env.VUE_APP_STATIC_DOMAIN_URL_CRM, process.env.VUE_APP_STATIC_DOMAIN_URL_CRM_ZK, process.env.VUE_APP_STATIC_DOMAIN_URL_SCHOOL);
    // const staticDomainURL = projectType==='crm' ? process.env.VUE_APP_STATIC_DOMAIN_URL_CRM : process.env.VUE_APP_STATIC_DOMAIN_URL_SCHOOL;
    if(projectType==='crm'){
        if(['1','137'].includes(store.getters.tenantId)){
            // crm中教
            staticDomainURL = process.env.VUE_APP_STATIC_DOMAIN_URL_CRM;
            console.log(10222,staticDomainURL);
            
        }else{
            // crm自考
            staticDomainURL = process.env.VUE_APP_STATIC_DOMAIN_URL_CRM_ZK;
        }
    }else{
        // 网校
        staticDomainURL = process.env.VUE_APP_STATIC_DOMAIN_URL_SCHOOL;
    }
    // console.log(1111112,staticDomainURL);
    if (!subStr)
        subStr = 'http';
    try {
        if (avatar && avatar.startsWith(subStr)) {
            return avatar;
        }
        else {
            if (avatar && avatar.length > 0 && avatar.indexOf('[') === -1) {
                console.log('获取图片路径：',projectType,`${staticDomainURL}/${avatar}`)
                return `${staticDomainURL}/${avatar}`;
            }
        }
    }
    catch (err) {
        return false;
    }
};

/**
 * 根据文件名称判断文件类型
 * @param: fileName - 文件名称
 * @param: 数据返回 1) 无后缀匹配 - false
 * @param: 数据返回 2) 匹配图片 - image
 * @param: 数据返回 3) 匹配 txt - txt
 * @param: 数据返回 4) 匹配 excel - excel
 * @param: 数据返回 5) 匹配 word - word
 * @param: 数据返回 6) 匹配 pdf - pdf
 * @param: 数据返回 7) 匹配 ppt - ppt
 * @param: 数据返回 8) 匹配 视频 - video
 * @param: 数据返回 9) 匹配 音频 - radio
 */
export const getFileType = fileName => {
    // 后缀获取
    let suffix = '';
    // 获取类型结果
    let result = '';
    try {
        const fileArr = fileName.split('.');
        suffix = fileArr[fileArr.length - 1];
    }
    catch (err) {
        suffix = '';
    }
    // fileName无后缀返回 false
    if (!suffix) {
        result = false;
        return result;
    }
    // 图片格式
    const imgList = [ 'png', 'jpg', 'jpeg', 'bmp', 'gif' ];
    // 进行图片匹配
    result = imgList.some(item => item === suffix);
    if (result) {
        result = 'image';
        return result;
    }
    // 匹配txt
    const txtList = ['txt'];
    result = txtList.some(item => item === suffix);
    if (result) {
        result = 'txt';
        return result;
    }
    // 匹配 excel
    const excelList = [ 'xls', 'xlsx' ];
    result = excelList.some(item => item === suffix);
    if (result) {
        result = 'excel';
        return result;
    }
    // 匹配 word
    const wordList = [ 'doc', 'docx' ];
    result = wordList.some(item => item === suffix);
    if (result) {
        result = 'word';
        return result;
    }
    // 匹配 pdf
    const pdfList = ['pdf'];
    result = pdfList.some(item => item === suffix);
    if (result) {
        result = 'pdf';
        return result;
    }
    // 匹配 ppt
    const pptList = ['ppt'];
    result = pptList.some(item => item === suffix);
    if (result) {
        result = 'ppt';
        return result;
    }
    // 匹配 视频
    const videoList = [ 'mp4', 'm2v', 'mkv' ];
    result = videoList.some(item => item === suffix);
    if (result) {
        result = 'video';
        return result;
    }
    // 匹配 音频
    const radioList = [ 'mp3', 'wav', 'wmv' ];
    result = radioList.some(item => item === suffix);
    if (result) {
        result = 'radio';
        return result;
    }
    // 其他 文件类型
    result = 'other';
    return result;
};

/**
 * 根据组件名获取父级
 * @param vm
 * @param name
 * @returns {Vue|null}
 */
export const getVmParentByName = (vm, name) => {
    let parent = vm.$parent;
    if (parent && parent.$options) {
        if (parent.$options.name === name) {
            return parent;
        }
        else {
            let res = getVmParentByName(parent, name);
            if (res) {
                return res;
            }
        }
    }
    return null;
};

/**
 * 关键信息隐藏
 * @param str 字符串
 * @param frontLen 字符串前面保留位数
 * @param endLen 字符串后面保留位数
 * @returns {string}
 */
export const hideCode = (str, frontLen, endLen) => {
    const len = str.length - frontLen - endLen;
    let hiddenStr = '';
    for (let i = 0; i < len; i++) {
        hiddenStr += '*';
    }
    return `${str.substring(0, frontLen)}${hiddenStr}${str.substring(str.length - endLen)}`;
};

/**
 * 过滤器类型
 * 0：学员
 * 2：订单
 * 3：订单课程
 * 4：支付明细
 * 5：赠送课程
 * 6：退费单
 * 7：退费明细
 * 8：报考
 * 9: 订金退费单
 * 10：订金退费单明细
 * 11: crm退费单
 * 99：IM用户信息（前端自定义，与后端无关）
 */
export const validatorFilterType = value => [ 0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 99 ].includes(value);

/**
 * RSA 解密数据
 * @param value
 * @returns {string | false}
 */
export const getRSAData = value => {
    const encrypt = new JSEncrypt();
    encrypt.setPrivateKey('MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBALU24+s2y3mHNx7KyC0uHz48P8UcrLbz7BvLOqA4zRPdP3XYIXhIVvA+zpBUgYiBaKObiwJAHFAiBMGr5B5MYBn8QbnhE83qLuN9G3ypxhx9U0rBi1PZSvhcEI6V6J5ubURJ2Gx/h2nckRWvXt1ztcjztm0KrLyr08NZub21D3mjAgMBAAECgYAhW5lZEx0hoeJjqLBwoKzfp/eVMVIZ24z7EM4Z8FrP7UphRwfiPG7Eiss7hlLR7gB1HYzZPTP5DEoT3LCBY03NK3EE4BUnbXOcX1FwYQJCB/x6+NYqStbva/wcMRtNWrupfkZl+puv9hFd+SmoiNrSa2niHNgSfOwS2F8LStRhAQJBANxhAXQFx6vQgL/UTyl/JQluCpwYFFwzdh2WcfHMTobJhdEMd6ThFegJV+eWAdfJ3vUatkQ53Z9H5e1Z/FUw1V0CQQDSgU7PpJzvtGp8ecXlDzhsdSU2EAqAdgSPCeVboh3d8RDD1V9xXMRMxyVza8rrTHBQLBBEMgliIvUYeM1jRZr/AkEA0SQST/xIQKrv9JzUv4nVKTzQPtCvSczgtDWZTyJYB5xqLTkKtmOR+ZIcZUA74YDH4Y4HGXpc85M1BmpWiLZ+VQJBAKvXm3quqt6TrYpH7mD7d9gyGVp05d3QehA6x91yDmer7z+u4+crD6SNvejnShOjptwL3IuPPVG7r9F2bFRp8gkCQQCQYhQbYcevtwY57hrHx70c3NwnW/O243J3WvM7mQg+YS3lZfNra1e1HEdeco8/hH/aXe8EikqVGOIj21LKvjde');
    return encrypt.decrypt(value);
};

/**
 * 判断两个对象是否相等
 * @param object1
 * @param object2
 * @returns {boolean}
 */
export const ifCompareObject = (object1, object2) => {
    const o1keys = Object.keys(object1);
    const o2keys = Object.keys(object2);
    console.log(298,o1keys, o2keys);
    // if (o2keys.length !== o1keys.length)
    //     return
    for (let i = 0; i <= o1keys.length - 1; i++) {
        let key = o1keys[i];
        if (!o2keys.includes(key))
            return key;
        if (object2[key] !== object1[key])
            return key;
    }
    return
};